import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { MobileFacet } from '../../components/mobile-facet/mobile-facet'
import { ariaLabel } from '../../utils/form-utilities'
import { SearchFiltersToggle } from '../../components/search-filters-toggle/search-filters-toggle'

export const FlexibleMonthlyPriceMin = withFilterContext(FilterName.min_monthly_price, SearchFiltersDropdown, {
    title: 'Min monthly price',
    ariaLabel: ariaLabel.monthlyPrice.min,
})
export const FlexibleMonthlyPriceMax = withFilterContext(FilterName.max_monthly_price, SearchFiltersDropdown, {
    title: 'Max monthly price',
    ariaLabel: ariaLabel.monthlyPrice.max,
})
export const FlexibleFinanceTerm = withFacetContext(
    FacetName.finance,
    withFilterContext(FilterName.term, SearchFiltersToggle, {
        title: 'How long do you want the finance for?',
        subTitle: "We'll allow for 1 month either side, so you don't miss any deals that might still suit you.",
    })
)
export const FlexibleFinanceDeposit = withFacetContext(
    FacetName.finance,
    withFilterContext(FilterName.deposit, SearchFiltersDropdown, {
        title: 'How much could you pay upfront?',
    })
)
export const FlexibleFinanceYearlyMileage = withFacetContext(
    FacetName.finance,
    withFilterContext(FilterName.yearly_mileage, SearchFiltersDropdown, {
        title: "What's your estimated mileage per year?",
        subTitle:
            "If we find deals with a higher mileage allowance for the same price or less, we'll show you those too.",
    })
)

export const MonthlyPriceMin = withFilterContext(FilterName.min_monthly_price, SearchFiltersDropdown, {
    ...rangeMin,
    ariaLabel: ariaLabel.monthlyPrice.min,
})
export const MonthlyPriceMax = withFilterContext(FilterName.max_monthly_price, SearchFiltersDropdown, {
    ...rangeMax,
    ariaLabel: ariaLabel.monthlyPrice.max,
})
export const FinanceTerm = withFacetContext(
    FacetName.finance,
    withFilterContext(FilterName.term, SearchFiltersToggle, {
        title: 'Term (months)',
    })
)
export const FinanceDeposit = withFacetContext(
    FacetName.finance,
    withFilterContext(FilterName.deposit, SearchFiltersDropdown, {
        title: 'Deposit',
    })
)
export const FinanceYearlyMileage = withFacetContext(
    FacetName.finance,
    withFilterContext(FilterName.yearly_mileage, SearchFiltersDropdown, {
        title: 'Mileage (per year)',
    })
)
export const MonthlyPriceExpander = withFacetContext(FacetName.monthly_price, MobileFacet)
